/* src/app/shared/common-ui/lib/dialog/dialog.component.less */
:host {
  display: none;
  animation-fill-mode: both;
  animation-timing-function: cubic-bezier(0.7, 0, 0.3, 1);
}
:host(.show) {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  z-index: 1000;
}
:host(.show) .overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  animation-duration: 0.3s;
  animation-name: anim-open-overlay;
  background: var(--color-default-overlay-background);
  opacity: 0.75;
}
.wrapper {
  display: flex;
  flex-direction: column;
  min-width: 30rem;
  margin: 3.6rem;
  animation-duration: 0.3s;
  animation-name: anim-open;
  background: var(--color-dropdown-popup-background);
  box-shadow:
    0 0.8rem 1rem 0.1rem rgba(0, 0, 0, 0.14),
    0 0.3rem 1.4rem 0.2rem rgba(0, 0, 0, 0.12),
    0 0.5rem 0.5rem -0.3rem rgba(0, 0, 0, 0.2);
  opacity: 1;
  z-index: 1;
}
.wrapper .content {
  flex: 1;
  display: flex;
  flex-direction: column;
  max-height: 50.4rem;
  margin: 3.6rem;
  overflow: hidden;
}
.wrapper.large {
  height: 68rem;
  width: 94rem;
  max-height: 68rem;
  max-width: 94rem;
}
.wrapper.large .content {
  max-height: 62rem;
}
@media only screen and (max-device-height: 414px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape), only screen and (max-device-height: 812px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) {
  .wrapper.large .content {
    max-height: initial;
    margin: 2.4rem;
  }
}
@media only screen and (max-device-height: 414px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape), only screen and (max-device-height: 812px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) {
  .wrapper.large {
    position: absolute;
    top: 1.2rem;
    left: 1.2rem;
    right: 1.2rem;
    bottom: 1.2rem;
    height: initial;
    width: initial;
    min-height: initial;
    max-height: 100%;
    min-width: initial;
    max-width: initial;
    margin: initial;
  }
}
.wrapper.fullScreen {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  min-height: initial;
  max-height: initial;
  min-width: initial;
  max-width: initial;
  margin: initial;
  animation-name: zoomIn;
  z-index: 900;
}
.wrapper.fullScreen .content {
  flex: 1;
  display: flex;
  flex-direction: column;
  max-height: initial;
}
.wrapper.fullScreen .fullscreenExit {
  position: absolute;
  top: 1.2rem;
  right: 1.2rem;
}
@media only screen and (min-width: 768px) {
  .wrapper {
    max-height: 57.6rem;
    max-width: 50rem;
  }
  .wrapper.large {
    max-height: 68rem;
    max-width: 94rem;
  }
  .wrapper.large .content {
    max-height: 62rem;
  }
}
@-webkit-keyframes anim-open-overlay {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 0.75;
  }
}
@keyframes anim-open {
  0% {
    transform: translate3d(0, calc(50vh + 50%), 0);
  }
  100% {
    transform: translate3d(0, 0, 0);
  }
}
@keyframes zoomIn {
  from {
    opacity: 0;
    transform: scale3d(0.1, 0.1, 0.1);
  }
  50% {
    opacity: 1;
  }
}
/*# sourceMappingURL=dialog.component.css.map */
